import Itemvideo from './Itemvideo';
import { useContext } from 'react';
import { ProducteContext } from 'context/3cat/ProducteProvider';
import Destacat from 'components/3cat/Destacat';

export default function Component(props) {
    const { isWebviewActive } = useContext(ProducteContext);
    if (isWebviewActive) {
        return <Destacat {...props} tipus={'itemVideoWebview'} linkId={props.id} />;
    }
    return <Itemvideo {...props} />;
}
